import {Injectable}                         from '@angular/core';
import {map}                                from 'rxjs/operators';
import {
  ApDynGridStatusColumnConfig
}                                           from '../../../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {nameOf}                             from '../../../../ap-core/utils/ap-name-of';
import {
  IGridStatus
}                                           from '../../../../ap-interface/interfaces/ap-grid-status.interface';
import {
  ApDynGridPropertyColumnConfig,
  FilterType
}                                           from '../../../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  ApDynGridColumnConfigBase,
  ApDynGridColumnHideConfig
}                                           from '../../../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {MapViewMode}                        from '../../../../ap-interface';
import {MapViewStore}                       from '../../../../stores/layout/mapview.store';
import {GetRoundNumericPipe}                from '../../../../ap-utils';
import {IFwPlanPlanningWizardSelectionData} from '../fw-plan-planning.types';
import ISettings = Data.BaseData.ISettings;

@Injectable()
export class FwPlanPlanningSelectionConfig {
  constructor(private mapViewStore: MapViewStore,
              private roundNumericPipe: GetRoundNumericPipe) {
  }

  /**
   * Generates grid columns configuration for the field selection grid
   * @param setting Settings configuration containing display preferences
   * @returns Array of grid column configurations including status, field numbers, name, area and crop columns
   * with appropriate filtering, sorting and display options
   * @public
   */
  public generateColumns(setting: ISettings): ApDynGridColumnConfigBase[] {
    return [
      new ApDynGridStatusColumnConfig({
        field: `${nameOf<IFwPlanPlanningWizardSelectionData>('Status')}.${nameOf<IGridStatus>('state')}`,
        class: `${nameOf<IFwPlanPlanningWizardSelectionData>('Status')}.${nameOf<IGridStatus>('class')}`,
        description: `${nameOf<IFwPlanPlanningWizardSelectionData>('Status')}.${nameOf<IGridStatus>('description')}`,
        filterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini__Number',
        field: nameOf<IFwPlanPlanningWizardSelectionData>('FieldNumber'),
        width: 60,
        cssClass: 'right',
        hide: true,
        filterable: true,
        filterType: FilterType.NUMBER,
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini_Subnumber',
        field: nameOf<IFwPlanPlanningWizardSelectionData>('FieldSecondNumber'),
        width: 60,
        cssClass: 'right',
        hide: true,
        filterable: true,
        filterType: FilterType.NUMBER,
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini__Number',
        field: nameOf<IFwPlanPlanningWizardSelectionData>('FieldCombinedNumber'),
        width: 70,
        hide: new ApDynGridColumnHideConfig({
          selfHide: this.mapViewStore.Listen(s => s.mode).pipe(
            map((mode) => mode === MapViewMode.HIDE)
          )
        }),
        filterable: true,
        headerFilterable: true,
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini__Name',
        field: nameOf<IFwPlanPlanningWizardSelectionData>('FieldName'),
        width: 180,
        sortIndex: 0,
        filterable: true,
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini__Area',
        field: nameOf<IFwPlanPlanningWizardSelectionData>('Area'),
        width: 60,
        cssClass: 'right',
        tooltip: (dataItem: IFwPlanPlanningWizardSelectionData) => dataItem?.Area?.toString(),
        filterable: true,
        filterType: FilterType.NUMBER,
        headerFilterable: true,
        pipes: [{
          pipe: this.roundNumericPipe,
          args: [setting.DigitsAfterDecimalPoint]
        }]
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Global__Crop',
        field: nameOf<IFwPlanPlanningWizardSelectionData>('CropName'),
        width: 100,
        filterable: true,
        cropColoring: true,
        headerFilterable: true
      })
    ];
  }
}
